import LazyLoad from "vanilla-lazyload"

export const lazyLoading = new LazyLoad({
  elements_selector: `[data-src]:not([data-fancybox]), [data-bg]`,
  callback_error: (img) => {
    img.setAttribute("srcset", `${window.location.origin}/images/svg/placeholder.svg 1x`);
    img.setAttribute("src", `${window.location.origin}/images/svg/placeholder.svg`);
    img.classList.add("fallback")
  }
})

const imgs = document.querySelectorAll<HTMLImageElement>(".img img:not([data-src])")

imgs.forEach(img => {
  const showPlaceholder = () => {
    img.setAttribute("srcset", `${window.location.origin}/images/svg/placeholder.svg 1x`);
    img.setAttribute("src", `${window.location.origin}/images/svg/placeholder.svg`);
    img.removeEventListener("error", showPlaceholder)
  }

  img.addEventListener("error", showPlaceholder)
})
